import { z } from "zod";
const IdSchema = z.uuid();
const IsoDateTimeSchema = z.iso.datetime({ offset: true });
const DateOnlySchema = z.iso.date();
const LocaleSchema = z.enum(["fr", "ar", "en"]);
const DEFAULT_LOCALE = "fr";
const RateBpSchema = z.int().min(0).max(1e6);
const OrgIdParamSchema = z.strictObject({ orgId: IdSchema });
export {
  DEFAULT_LOCALE,
  DateOnlySchema,
  IdSchema,
  IsoDateTimeSchema,
  LocaleSchema,
  OrgIdParamSchema,
  RateBpSchema
};
//# sourceMappingURL=primitives.js.map